import { createFileRoute } from '@tanstack/react-router';
import EntityTemplateView from '@features/entity-templates/EntityTemplateView';

export const Route = createFileRoute('/w/entity-templates/view/$templateId')({
  staticData: {
    breadcrumb: 'View Template',
    breadcrumbKey: 'K_BREADCRUMB_VIEW_TEMPLATE',
  },
  component: EntityTemplateViewPage,
});

function EntityTemplateViewPage() {
  const { templateId } = Route.useParams();
  return <EntityTemplateView templateId={templateId} />;
}
